module.exports = __webpack_public_path__ + "img/sign-out.5d03763b.svg";